module.exports = {
    apiKey: "AIzaSyAKJre8b5VSARYMjCQ6biPxK_8peiXCE4k",
    authDomain: "afya-uat.firebaseapp.com",
    databaseURL: "https://afya-uat.firebaseio.com",
    projectId: "afya-uat",
    storageBucket: "afya-uat.appspot.com",
    messagingSenderId: "758475956656",
    appId: "1:758475956656:web:4e20da62ce888e357e3675",
    measurementId: "G-445SW8BEE8"
  };